import { Component, OnInit } from '@angular/core';
import { WindowService } from '../../../../../../common/angular-shared/services/window/window.service';
import { CoverpathUtils } from '../../../../../../coverpath-common/js/static/CoverpathUtils';

@Component({
  moduleId: module.id,
  selector: 'cp-footer',
  templateUrl: './footer.component.html',
})
export class FooterComponent implements OnInit {
  date: Date = new Date();
  version: string;
  showCRN: boolean;
  copyrightYear: number = CoverpathUtils.getCopyrightYear();

  constructor(private windowService: WindowService) {
    this.version = this.windowService.nativeWindow.__ver;
  }

  ngOnInit() {
    // HL-17855
    this.showCRN = false;
  }
}
